/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */
import './LinkButton.scss';

import { isEmpty, isString } from 'lodash';
import { bool, object, string } from 'prop-types';
import React from 'react';
import { linkBuilder } from 'services/Externals';

import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';

const Link = ({
  link,
  linkTarget,
  children,
  className,
  disabled = false,
  view,
  ...props
}) => {
  const linkComponent = (
    <a href={linkBuilder(link, view)} target={linkTarget} {...props}>
      {children}
    </a>
  );

  return disabled ? (
    <span
      className={`${className} link-disable`}
      onClickCapture={(e) => e.preventDefault()}>
      {linkComponent}
    </span>
  ) : (
    <span className={className}>{linkComponent}</span>
  );
};

const LinkWithPermissions = WithUserPermissions(Link);
const LinkButton = ({
  className = '',
  link,
  text = 'Cancel',
  children = text,
  disabled = false,
  linkTarget = '_self',
  withPermissions,
  shouldDisable,
  view,
  ...props
}) => {
  const baseClassName = 'link-button no-underline';
  const classNames = `${baseClassName} ${className}`;

  if (isString(link) && !isEmpty(link)) {
    return withPermissions ? (
      <LinkWithPermissions
        link={link}
        linkTarget={linkTarget}
        className={classNames}
        shouldDisable={shouldDisable}
        view={view}
        {...props}>
        {children}
      </LinkWithPermissions>
    ) : (
      <Link
        link={link}
        linkTarget={linkTarget}
        className={classNames}
        disabled={disabled}
        view={view}
        {...props}>
        {children}
      </Link>
    );
  }
  return (
    <a className={classNames} {...props}>
      {children}
    </a>
  );
};

LinkButton.propTypes = {
  className: string,
  disabled: bool,
  link: string,
  linkTarget: string,
  shouldDisable: bool,
  text: string,
  view: object,
  withPermissions: bool
};

export default LinkButton;
